import React from 'react';
import styles from './Css/Good.module.css';
import { useSelector } from 'react-redux';
import CounterGood from './../../Components/ActionButtons/CounterGood';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import ImageFlyPortal from './../../Components/ImageFlyPortal';
import { useTranslation } from 'react-i18next';
import StarMini from './../../Assets/Gif/star-mini.gif';
import HeaderBlock from "../Blocks/HeaderBlock";
import { toProductThumbnailUrl } from '../../utils/mediaUrl';

const GoodDialog = React.lazy(() => import('./../../Components/Dialogs/GoodDialog'));

class ProductDialogErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('Product dialog error', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    role="alert"
                    style={{
                        position: 'fixed',
                        inset: 0,
                        zIndex: 10200,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 24,
                        background: 'var(--tg-theme-bg-color)',
                        color: 'var(--tg-theme-text-color)'
                    }}
                >
                    <button className="btn mainButton" onClick={this.props.onClose}>
                        {this.props.returnLabel}
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

const GoodCard = ({ good, currentPage, setOpenGoodModalLocal, handleChangeShopIDSearchGoods, clone = false, priority = false }) => {
    const {t} = useTranslation();
    const [openGoodModal, setOpenGoodModal] = React.useState(false);
    const [isFlying, setIsFlying] = React.useState(false);
    const [flyImageSrc, setFlyImageSrc] = React.useState('');
    const BasketList = Object.values(useSelector(state => state.shop.basket));
    const SettingsSession = useSelector(state => state.shop.shop.settings);
    const cardPhoto = toProductThumbnailUrl(good.photo, SettingsSession.col === 12 ? 420 : 360);
    const item = good.type !== 'ad' ? good.sizes == '0' ? BasketList.find(item => item.item_id === good.id) : null : null;

    const handleClickOpenGoodModal = () => {
        setOpenGoodModal(true);
        setOpenGoodModalLocal(true);
    };

    const handleCloseGoodModal = () => {
        setOpenGoodModal(false);
        setOpenGoodModalLocal(false);
    };

    const handleAddToBasket = (good) => {
        setFlyImageSrc(good.photo);
        setIsFlying(true);
        setTimeout(() => {
            setIsFlying(false);
        }, 1000); // Продолжительность анимации
    };

    const filteredItems = good.type !== 'ad' ? BasketList.filter(item => item.sizes !== '0' && item.item_id === good.id) : null;
    const [openCostsChange, setOpenCostsChange] = React.useState(false);
    const totalCountWithSize = good.type !== 'ad' ? filteredItems.reduce((acc, item) => acc + item.count, 0) : null;

    const hasCostsChange = typeof good?.costs_change === 'string' && good.costs_change.trim() !== '';
    const hasLastCost = Number(good?.last_cost) > 0;
    const goodTimestamp = typeof good?.timestamp === 'string'
        ? new Date(good.timestamp.replace(' ', 'T')).getTime()
        : Number.NaN;
    const isRecentlyAdded = Number.isFinite(goodTimestamp)
        && Date.now() - goodTimestamp < 7 * 24 * 60 * 60 * 1000;
    const formatPrice = (value) => {
        const price = Number(value);
        return Number.isFinite(price) ? price.toLocaleString('ru-RU') : '0';
    };

    const parsePriceRanges = (costsChange, defaultCost) => {
        if (typeof costsChange !== 'string' || costsChange.trim() === '') {
            return [];
        }

        const ranges = costsChange.split(',').map(range => {
            const [quantity, price] = range.split('-');
            return { minQuantity: parseInt(quantity), price: parseInt(price) };
        }).filter(range => !Number.isNaN(range.minQuantity) && !Number.isNaN(range.price));

        if (ranges.length === 0 || ranges[0].minQuantity !== 0) {
            ranges.unshift({ minQuantity: 0, price: defaultCost });
        }

        return ranges.sort((a, b) => a.minQuantity - b.minQuantity);
    };

    function extractLastNumber(str) {
        if (typeof str !== 'string' || str.trim() === '') {
            return null;
        }

        const parts = str.split(',');
        const lastPart = parts[parts.length - 1];
        const numbers = lastPart.split('-');
        const value = parseInt(numbers[numbers.length - 1]);
        return Number.isNaN(value) ? null : value;
    }

    if(good !== undefined && good.type !== 'ad') {
        if (hasCostsChange) {
            const lastCost = extractLastNumber(good.costs_change);
            if (lastCost !== null) {
                good.cost = lastCost;
            }
        }
    }

    var isClient = false;
    if(SettingsSession.Cs !== false) {
        if(SettingsSession.Cs.includes(good.shopID)) {
            isClient = true;
        }
    }

    const [isHided, setIsHided] = React.useState(good.hided === 1 ? true : false);

    const styleCounterTop = SettingsSession.col < 6 ? {
        width: 23,
        height: 23,
        fontSize: 10,
        left: "82%"
    } : {};

    const renderGoodDialog = (dialogProps = {}) => (
        openGoodModal ? (
            <ProductDialogErrorBoundary
                onClose={handleCloseGoodModal}
                returnLabel={t('return_to_catalog')}
            >
                <React.Suspense fallback={null}>
                    <GoodDialog
                        handleChangeShopIDSearchGoods={handleChangeShopIDSearchGoods}
                        currentPage={currentPage}
                        open={openGoodModal}
                        setOpen={setOpenGoodModal}
                        handleClickOpen={handleClickOpenGoodModal}
                        handleClose={handleCloseGoodModal}
                        good={good}
                        setOpenGoodModalLocal={setOpenGoodModalLocal}
                        setIsHidedCard={setIsHided}
                        {...dialogProps}
                    />
                </React.Suspense>
            </ProductDialogErrorBoundary>
        ) : null
    );

    return (
        <>
            <ImageFlyPortal imgSrc={flyImageSrc} isFlying={isFlying} onAnimationEnd={() => setIsFlying(false)} />
            {
                good.type !== 'ad' ? (
                    <>
                        <div className={`${styles.blockGood} storefront-product-card ${hasLastCost ? 'storefront-product-card--sale' : ''} ${isRecentlyAdded ? 'storefront-product-card--new' : ''} ${SettingsSession.col === 12 ? ('row') : ''}`}>
                            <div className={`imageBlockList storefront-product-media ${SettingsSession.col === 12 && (' col-5')} mb-1 ${SettingsSession.photo_type == 1 ? "aspectRatio1" : ''}`}>
                                <div className="image-block-list" onClick={handleClickOpenGoodModal}>
                                    {
                                        good.hided === 1 ? (
                                            <>
                                                <p className="textitemHided">{t('product_is_out_of_stock')}</p>
                                                {/\.(mp4|webm|ogg)$/i.test(good.photo) ? (
                                                    <video
                                                        src={good.photo}
                                                        autoPlay
                                                        loop
                                                        muted
                                                        preload={priority ? "metadata" : "none"}
                                                        className="goodIsHided"
                                                        style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                                    />
                                                ) : (
                                                    <img
                                                        src={cardPhoto}
                                                        alt={good.photo}
                                                        loading={priority ? "eager" : "lazy"}
                                                        fetchPriority={priority ? "high" : "auto"}
                                                        decoding="async"
                                                        className="goodIsHided"
                                                    />
                                                )}
                                            </>
                                        ) : (
                                            /\.(mp4|webm|ogg)$/i.test(good.photo) ? (
                                                <video
                                                    src={good.photo}
                                                    autoPlay
                                                    loop
                                                    muted
                                                    preload={priority ? "metadata" : "none"}
                                                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                                />
                                            ) : (
                                                <img
                                                    src={cardPhoto}
                                                    alt={good.photo}
                                                    loading={priority ? "eager" : "lazy"}
                                                    fetchPriority={priority ? "high" : "auto"}
                                                    decoding="async"
                                                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                                />
                                            )
                                        )
                                    }
                                    {
                                        good.containerTag !== undefined && (
                                            <div className="containerTag mainButton"
                                                 onClick={() => handleChangeShopIDSearchGoods(good.shopID, good.containerTag)}>
                                                {
                                                    good.containerTag.length > 14
                                                        ? good.containerTag.substring(0, 14) + '...'
                                                        : good.containerTag
                                                }
                                            </div>
                                        )
                                    }
                                    {
                                        isClient && (
                                            <div className="webappzTag"
                                                 onClick={() => handleChangeShopIDSearchGoods(good.shopID, good.containerTag)}>
                                                {t('added_the_webappz_ai')}
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            <div className={`storefront-product-content ${SettingsSession.col === 12 && (' col-7 pl-2')}`}>
                                <div
                                    className={`d-flex ${SettingsSession.col !== 12 && 'justify-content-between'} align-items-center w-100`}
                                    data-product-meta="price"
                                    style={{marginTop: 0}}>
                                    <div style={{
                                        whiteSpace: "nowrap",
                                        width: "max-content",
                                        display: "flex",
                                        alignItems: "center"
                                    }}>
                                        <b style={{padding: 0, margin: 0, display: "flex", alignItems: "center"}} className={`storefront-product-price ${good.isDigit === true ? "telegramStarColor" : "mainText"}`}>
                                            {formatPrice(good.cost)} { good.isDigit === true ? (<img src={StarMini}
                                                                                                               alt=""
                                                                                                               loading="lazy"
                                                                                                               decoding="async"
                                                                                                               style={{width: "18px", color: "var(--tg-theme-text-color)"}}/>) : SettingsSession.currency_sign }
                                        </b>
                                        {
                                            hasCostsChange && !clone && (
                                                <div
                                                    className="bg-warning rounded-circle text-white align-items-center justify-content-center"
                                                    style={{width: 25, height: 25, display: "flex", marginLeft: 7}}
                                                    onClick={() => setOpenCostsChange(true)}
                                                >
                                                    <b>!</b>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <small
                                        className={`text-muted d-flex align-items-center ${SettingsSession.col === 12 && ' ml-2 justify-content-between'} last_cost`}>
                                        {
                                            hasLastCost ? (
                                                <>
                                                    {formatPrice(good.last_cost)}
                                                    {
                                                        good.isDigit === true ?
                                                        (
                                                        <img
                                                            src={StarMini}
                                                            alt=""
                                                            loading="lazy"
                                                            decoding="async"
                                                            style={{
                                                                width: "14px",
                                                                color: "var(--tg-theme-text-color)"
                                                            }}/>
                                                        )
                                                        : SettingsSession.currency_sign
                                                    }
                                                </>
                                            ) : (<></>)
                                        }
                                    </small>
                                </div>
                                {
                                    SettingsSession.show_art === 1 ? (
                                        <b className="storefront-product-sku" style={{fontSize: 10, marginTop: 0, display: "flex"}}>{t('art.')} {good.vendor_code !== undefined && good.vendor_code.length > 0 ? good.vendor_code : good.id}</b>
                                    ) : SettingsSession.show_art === 2 && good.vendor_code !== undefined && good.vendor_code.length > 0 ? (
                                        <b className="storefront-product-sku" style={{fontSize: 10, marginTop: 0, display: "flex" }}>{t('art.')} {good.vendor_code}</b>
                                    ) : SettingsSession.show_art === 2 && good.vendor_code !== undefined && good.vendor_code.length < 1 ? (
                                        <div style={{height: 15}}>

                                        </div>
                                    ) : null
                                }
                                <div className="itemBlockHeader">
                                <h6 style={{fontSize: "14px"}} className="multi-line-ellipsis storefront-product-title">
                                        {good.title}
                                    </h6>
                                </div>
                                <div className="storefront-product-actions" style={SettingsSession.col === 12 ? {paddingRight: "50%", marginTop: -10} : {marginTop: -10}}>
                                    {
                                        good.hided === 1 ? (
                                            <>
                                                <button className="mainButton btn-sm btn w-100 disabled"
                                                        onClick={handleClickOpenGoodModal}
                                                        style={{height: 36.5}}
                                                        disabled>{t('will_be_soon')}
                                                </button>
                                                {renderGoodDialog()}
                                            </>
                                        ) : (
                                            <>
                                                {
                                                    !clone ? (
                                                        <>
                                                            {
                                                                good.redirect_link !== null && good?.redirect_link?.length > 0 ? (
                                                                    <>
                                                                        <Button className="mainButton btn w-100 animated-button"
                                                                                onClick={() => {
                                                                                    window.Telegram.WebApp.openLink(good.redirect_link);
                                                                                }}
                                                                                style={{height: 36.5}}>
                                                                            <svg viewBox="0 0 24 24" fill="none"
                                                                                 xmlns="http://www.w3.org/2000/svg"
                                                                                 width={"16px"}
                                                                                 height={"16px"}
                                                                            >
                                                                                <g id="SVGRepo_bgCarrier"
                                                                                   strokeWidth="0"></g>
                                                                                <g id="SVGRepo_tracerCarrier"
                                                                                   strokeLinecap="round"
                                                                                   strokeLinejoin="round"></g>
                                                                                <g id="SVGRepo_iconCarrier">
                                                                                    <path
                                                                                        d="M15.197 3.35462C16.8703 1.67483 19.4476 1.53865 20.9536 3.05046C22.4596 4.56228 22.3239 7.14956 20.6506 8.82935L18.2268 11.2626M10.0464 14C8.54044 12.4882 8.67609 9.90087 10.3494 8.22108L12.5 6.06212"
                                                                                        stroke="#fff" strokeWidth="1.5"
                                                                                        strokeLinecap="round"></path>
                                                                                    <path
                                                                                        d="M13.9536 10C15.4596 11.5118 15.3239 14.0991 13.6506 15.7789L11.2268 18.2121L8.80299 20.6454C7.12969 22.3252 4.55237 22.4613 3.0464 20.9495C1.54043 19.4377 1.67609 16.8504 3.34939 15.1706L5.77323 12.7373"
                                                                                        stroke="#fff" strokeWidth="1.5"
                                                                                        strokeLinecap="round"></path>
                                                                                </g>
                                                                            </svg>
                                                                            <small className={"ml-1"}>{t('buy')}</small>
                                                                        </Button>
                                                                        {renderGoodDialog({onAdd: () => handleAddToBasket(good)})}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {
                                                                            good.sizes == '0' ? (
                                                                                item ? (
                                                                                    <>
                                                                                        <CounterGood card="card" count={item.count}
                                                                                                     basketID={item.id}
                                                                                                     onAdd={() => handleAddToBasket(good)}/>
                                                                                        {renderGoodDialog({onAdd: () => handleAddToBasket(good)})}
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <CounterGood card="card-add" good={good}
                                                                                                     size="0"
                                                                                                     onAdd={() => handleAddToBasket(good)}
                                                                                        />
                                                                                        {renderGoodDialog()}
                                                                                    </>
                                                                                )
                                                                            ) : (
                                                                                <>
                                                                                    <Button
                                                                                        className="mainButton btn w-100 animated-button"
                                                                                        onClick={handleClickOpenGoodModal}
                                                                                        style={{height: 36.5}}
                                                                                    >
                                                                                        <small>{t('addToBasket')}</small>
                                                                                    </Button>
                                                                                    {renderGoodDialog({onAdd: () => handleAddToBasket(good)})}
                                                                                    {
                                                                                        totalCountWithSize > 0 && (
                                                                                            <div className="totalCountGoods mainButton"
                                                                                                 onClick={handleClickOpenGoodModal} style={styleCounterTop}>
                                                                                                {totalCountWithSize}
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                </>
                                                                            )
                                                                        }
                                                                    </>
                                                                )
                                                            }
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Button className="mainButton w-100"
                                                                    onClick={() => clone(good, JSON.parse(good.sizes))}>{t('addToBasket')}</Button>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }

                                </div>
                            </div>
                        </div>
                        <React.Fragment>
                            <Dialog
                                open={openCostsChange}
                                onClose={() => setOpenCostsChange(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                sx={{zIndex: "10200 !important", borderRadius: 10}}
                                className={"borderRadiusAlert"}
                            >
                                <DialogTitle id="alert-dialog-title">
                                </DialogTitle>
                                <DialogContent>
                                    <div style={{ padding: "12px" }}>
                                        <HeaderBlock>{t('price_may_vary_depending_on_the_quantity')}</HeaderBlock>
                                        <div>
                                            {
                                                hasCostsChange && (
                                                    <React.Fragment>
                                                        {
                                                            parsePriceRanges(good.costs_change).map((uslovie, index) => (
                                                                <p key={index}>{t('price_range', {minQuantity: uslovie.minQuantity, price: uslovie.price})}</p>
                                                            ))
                                                        }
                                                    </React.Fragment>
                                                )
                                            }
                                        </div>
                                    </div>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setOpenCostsChange(false)}>{t('see')}</Button>
                                </DialogActions>
                            </Dialog>
                        </React.Fragment>
                    </>
                ) : (
                    <a className="col-12" style={{padding: 4}} href={good.url}>

                        <div className="border rounded text-center p-2">
                            <img src={cardPhoto} width="100%" alt={good.title} loading="lazy" decoding="async"/>
                            <b><h5 style={{color: "var(--tg-theme-text-color)"}}>{good.title}</h5></b>
                        </div>

                    </a>
                )
            }
        </>
    );
};

export default GoodCard;
